import { useState, useEffect } from 'react';
import { Header } from '../../../common/Header/Header.jsx';
import { useParams } from 'react-router-dom';
import { membershipService } from '../../../../services/membershipService.js';
import { notify } from '../../../../assets/helpers/toast.js';
import { OrderCard } from './OrderComponents.jsx';
import { UpgradeInfoCard } from './UpgradeInfoCard.jsx';
import { renameMembershipStatus } from '../../../../assets/helpers/funciones.js';
import './Order.scss';

export const UpgradeOrder = () => {
  const { membershipId } = useParams();
  const [membership, setMembership] = useState('');


  const getSalesMembershipById = (membershipId) => {
    membershipService
      .getSalesMembershipById(membershipId)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setMembership(response?.data);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch((error) => { });
  };


  const reloadMembership = () => {
    getSalesMembershipById(membershipId);
  };


  useEffect(() => {
    getSalesMembershipById(membershipId);
  }, []);

  return (
    <>
      <Header />
      {membership && (
        <div className="service-with-container container">
          <h1 className="title-component">
            Upgrade Orden Nro. {membership?.membershipId} (
            {renameMembershipStatus(membership?.membershipStatus)})
          </h1>
          <div className="breadcrumb-container"></div>
          <div className="filter-button-container"></div>
          <br />
          <div className="row">
            <div className="col-12 col-lg-9">
              <UpgradeInfoCard
                label={'INFORMACIÓN DE RENOVACION'}
                membership={membership}
                reloadMembership={reloadMembership}
              />
            </div>
            <div className="col-12 col-lg-3">
              <OrderCard
                membership={membership}
                refresh={() => getSalesMembershipById(membershipId)}
                hideCancelButton={true}
              />{' '}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
